import React, { createContext, useContext, ReactNode } from "react";

// Define the shape of your feature flags
export interface FeatureFlag {
  [featureName: string]: boolean | FeatureFlag;
}

// Create a context for your flags
const FeatureFlagContext = createContext<FeatureFlag>({});

// Create a hook for easy access to your flags
const useFeatureFlag = <T extends FeatureFlag>(): T => {
  const flags = useContext(FeatureFlagContext) as FeatureFlag;
  return flags as T;
};

// Define the type of your props including children
export interface FeatureFlagProviderProps<T extends FeatureFlag> {
  flags: T;
  children: ReactNode;
}

// Create a provider to wrap your application
const FeatureFlagProvider = <T extends FeatureFlag>({ flags, children }: FeatureFlagProviderProps<T>) => (
  <FeatureFlagContext.Provider value={flags}>{children}</FeatureFlagContext.Provider>
);

export { FeatureFlagProvider, useFeatureFlag };
